import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { setCurrency } from "../lib/format";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [household, setHousehold] = useState(null);
  const [membership, setMembership] = useState(null);
  const [pending, setPending] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadHousehold = useCallback(async () => {
    try {
      const { data } = await api.get("/households/mine");
      setHousehold(data.household);
      setMembership(data.membership);
      setPending(data.pending || null);(data.household?.currency);
    } catch {
      setHousehold(null);
      setMembership(null);
    }
  }, []);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      await loadHousehold();
    } catch {
      setUser(null);
      setHousehold(null);
      setMembership(null);
    } finally {
      setLoading(false);
    }
  }, [loadHousehold]);

  useEffect(() => {
    // CRITICAL: skip the /me check if returning from OAuth callback
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    reload();
  }, [reload]);

  const login = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setUser(null);
    setHousehold(null);
    setMembership(null);
    window.location.href = "/login";
  };

  const role = membership?.role || null;

  return (
    <AuthContext.Provider
      value={{ user, household, membership, pending, role, loading, login, logout, reload, loadHousehold, setUser }}
    >
      {children}
    </AuthContext.Provider>
  );
}
